import React, { useState } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "components/ui/popover";
import { Settings } from "lucide-react";
import CalendarSetting from "./CalendarSetting";
import DatePicker from "components/app/function/DatePicker";
import SearchBar from "components/app/search-bar/SearchBar";

const CalendarNavbar = () => {
  const [openPopoverSetting, setOpenPopoverSetting] = useState<number | null>(null);

  return (
    <nav className="border-gray-200 pt-5 flex items-center justify-between">
      <Popover open={openPopoverSetting === 1} onOpenChange={(isOpen) => setOpenPopoverSetting(isOpen ? 1 : null)}>
        <PopoverTrigger asChild>
          <label
            htmlFor=""
            className="hover:border-3  transition-all  duration-300 ms-3 font-semibold rounded-full lg:w-10 lg:h-10 md:w-10 md:h-10 w-8 h-8 flex items-center justify-center cursor-pointer border border-gray-300 text-md"
          >
            <Settings />
          </label>
        </PopoverTrigger>
        <PopoverContent className="w-auto overflow-scroll">
          <CalendarSetting />
        </PopoverContent>
      </Popover>

      <div className="flex items-center gap-2 ms-5">
        <DatePicker className="py-4 h-[40px] w-[150px] border border-gray-300" onChange={(value: any) => {}} value="" />
      </div>
      <div className="flex items-center gap-2">
        <div className="flex-1 ms-4 me-2">
          <div className="relative">
            <SearchBar placeholder="Search" onValueChange={() => {}} />
          </div>
        </div>
      </div>
    </nav>
  );
};

export default CalendarNavbar;
